// extracted by mini-css-extract-plugin
export var form = "USAWaitingList-module--form--aaf81";
export var message = "USAWaitingList-module--message--93163";
export var section = "USAWaitingList-module--section--b2afc";
export var subheading = "USAWaitingList-module--subheading--94c7a";
export var title = "USAWaitingList-module--title--cdd63";